<template>
  <div class="content" :key="slug">
    <div class="hero">
      <div class="hero__contents wrapper">
        <div class="titles">
          <h3 class="titles__subtitle">{{ p.name }}</h3>
          <h2 class="titles__title">{{ p.prefix }} <br/>
            <span v-if="!p.notforgood" class="framed">for good<br/></span>
            {{ p.suffix }}
          </h2>
        </div>
        <div class="hero__illustration">
          <img :src="p.illustration.src" :alt="'Image: '+ p.illustration.alt"/>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <ul class="specs">
        <li v-for="_spec in p.specs" :key="_spec.descr">
          <p><strong>{{_spec.title}}</strong></p>
          <p><span>{{_spec.descr}}</span></p>
        </li>
      </ul>
    </div>

    <div class="modules">
      <template v-for="_m in p.modules">

        <div v-if="_m.type == 'paragraph'" :key="_m.text" :class="'wrapper wrapper--small paragraph ' + (_m.big ? 'paragraph--big' : '') ">
          <p class="">{{ _m.text }}</p>
        </div>

        <div v-if="_m.type == 'iframe'" :key="_m.code" :class="'iframe ' + (_m.fullscreen ? '' : 'wrapper') ">
          <div v-html="_m.code"></div>
          <figcaption v-if="_m.caption">{{ _m.caption }}</figcaption>
        </div>

        <figure v-if="_m.type == 'img'" :key="_m.src" :class="'image ' + (_m.fullscreen ? '' : 'wrapper') ">
          <img :src="_m.src" :alt="'Image: '+ _m.caption"/>
          <figcaption v-if="_m.caption" class="wrapper">{{ _m.caption }}</figcaption>
        </figure>

        <figure v-if="_m.type == 'video'" :key="_m.src" :class="'video ' + (_m.fullscreen ? '' : 'wrapper') ">
          <video v-if="_m.controls" :src="_m.src" :alt="_m.caption" autoplay loop muted controls></video>
          <video v-if="!_m.controls" :src="_m.src" :alt="_m.caption" autoplay loop muted></video>
          <figcaption v-if="_m.caption">{{ _m.caption }}</figcaption>
        </figure>

        <figure v-if="_m.type == 'device'" :key="_m.src" class="device wrapper wrapper--medium">
          <div class="device__figure iphoneX" v-if="_m.device == 'iphoneX'">
            <img class="device__figure__frame" src="/img/iphonex_frame.png" alt="iPhone X" />
            <video class="device__figure__screen" :src="_m.src" :alt="_m.caption" autoplay loop muted></video>
          </div>
          <figcaption v-if="_m.title">
            <h3>{{ _m.title }}</h3>
            <p>{{ _m.text }}</p>
          </figcaption>
        </figure>

        <div v-if="_m.type == 'cta'" :key="_m.url" class="titles wrapper cta">
          <h3 class="titles__subtitle">{{ _m.subtitle }}</h3>
          <h2 class="titles__title"><a :href="_m.url" target="_blank">→ {{ _m.title }}</a></h2>
        </div>

        <div v-if="_m.type == 'credits'" :key="_m.id" class="wrapper credits">
          <h3 class="credits__title">{{ _m.title }}</h3>
          <ul>
            <li v-for="_role in _m.roles" :key="_role.name">
              <strong>{{_role.title}}: </strong>
              <span>{{_role.name}}</span>
            </li>
          </ul>
        </div>

      </template>
    </div>

    <footer class="projects next-project">

      <router-link  :to="{name: 'Project', params: {slug: p.next}}" class="projects__item">
        <div class="titles wrapper">
          <h3 class="titles__subtitle">Next project: {{ projects[p.next].name}}</h3>
          <h2 class="titles__title">{{ projects[p.next].prefix }} <br/>
            <span v-if="!projects[p.next].notforgood" class="framed">for good<br/></span>
            {{ projects[p.next].suffix }}
          </h2>
          <span class="view-btn">View project</span>
        </div>
      </router-link>

    </footer>


  </div>
</template>

<script>

import Projects from '@/assets/contents/projects.json';
import ProjectHero from '@/components/_ProjectHero.vue';

export default {
  name: 'Projects',
  data () {
    return {
      projects: Projects,
      slug: this.$route.params.slug
    }
  },
  components: {
    //ProjectHero
  },
  created() {
    window.scrollTo(0, 0);
    
    this.p = this.projects[this.slug];
    
    /** Change page theme:  */
    const styles = document.styleSheets[0];
    styles.addRule('body', `background: white;`);
    styles.addRule('body', `color: ${this.p.textColor};`);
    
    styles.addRule('.header', `color: ${this.p.textColor};`);
    styles.addRule('.header .btn', `background: ${this.p.bgColor};`);
    styles.addRule('.header .btn::before', `background: ${this.p.secondaryColor};`);

    styles.addRule('.hero', `color: ${this.p.textColor};`);
    styles.addRule('.hero', `background: ${this.p.bgColor};`);

    styles.addRule(`.next-project .projects__item:hover`, `color: ${this.projects[this.p.next].textColor};`);
    styles.addRule(`.next-project .projects__item:hover`, `background: ${this.projects[this.p.next].bgColor};`);
  },
  mounted() {
    
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* background: p.bgColor, cZZZolor: p.textColor */
</style>



// WEBPACK FOOTER //
// src/components/Project.vue